// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("../attachment_box");
require("../wizard_lessons");
require("../auth_modal");
require("channels");
require("trix");
require("@rails/actiontext");
require("chartkick"); // yarn add chartkick chart.js
require("chart.js");
require("jquery-ui-dist/jquery-ui");
require("selectize");

import { addPrefetchToLinks } from "../add_auto_prefetch";
import PrefetchModule from "../prefetch.js";
import "bootstrap";
import "../trix-editor-overrides";
import "cocoon-js";
import "youtube";
import Glide from "@glidejs/glide";

//require("../stylesheets/application.scss");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

$(document).on("turbolinks:load", function () {
  window.scrollTo(0, 0);
  addPrefetchToLinks();
  PrefetchModule.setupPrefetch();
  document.getElementsByTagName("a");

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
  });

  $(".chapter-sortable").sortable({
    axis: "y",
    cursor: "grabbing",
    placeholder: "ui-state-highlight",

    update: function (_, ui) {
      let item = ui.item;
      let itemData = item.data();
      let params = { _method: "put" };

      params[itemData.modelName] = { row_order_position: item.index() };

      $.ajax({
        type: "POST",
        url: itemData.updateUrl,
        dataType: "json",
        data: params,
      });
    },
  });

  $(".lesson-sortable").sortable({
    axis: "y",
    cursor: "grabbing",
    placeholder: "ui-state-highlight",
    connectWith: ".lesson-sortable",

    update: function (_, ui) {
      if (ui.sender) return;

      let item = ui.item;
      let itemData = item.data();
      let chapterID = item.parents(".ui-sortable-handle").eq(0).data().id;
      let params = { _method: "put" };

      params[itemData.modelName] = {
        row_order_position: item.index(),
        chapter_id: chapterID,
      };

      $.ajax({
        type: "POST",
        url: itemData.updateUrl,
        dataType: "json",
        data: params,
      });
    },
  });

  $("video").bind("contextmenu", function () {
    return false;
  });

  if ($(".selectize")) {
    $(".selectize").selectize({
      sortField: "text",
    });
  }

  $(".selectize-tags").selectize({
    create: function (input, callback) {
      $.post("/tags.json", { tag: { name: input } }).done(function (response) {
        console.log(response);
        callback({ value: response.id, text: response.name });
      });
    },
    render: {
      option_create: function (data, escape) {
        var addString = "Agregar";
        return (
          '<div class="create">' +
          addString +
          " <strong>" +
          escape(data.input) +
          "</strong>&hellip;</div>"
        );
      },
    },
  });

  const openMenu = (event) => {
    event.preventDefault();
    $("#user_menu").toggleClass("menu-open");
  };

  const closeMenu = (event) => {
    event.preventDefault();
    $("#user_menu").toggleClass("menu-open");
  };

  $(".navbar .navbar-user-button").on("click", openMenu);
  $("#user_menu .close-user-menu").on("click", closeMenu);
  
  /*$(".dropdown-menu a.dropdown-toggle").on("click", function (e) {
    if (!$(this).next().hasClass("show")) {
      $(this)
        .parents(".dropdown-menu")
        .first()
        .find(".show")
        .removeClass("show");
    }
    var $subMenu = $(this).next(".dropdown-menu");
    $subMenu.toggleClass("show");

    $(this)
      .parents("li.nav-item.dropdown.show")
      .on("hidden.bs.dropdown", function (e) {
        $(".dropdown-submenu .show").removeClass("show");
      });

    return false;
  });*/

  function toggleChangeEyeIcon() {
    const password = this.parentElement.querySelector("input");
    const type =
      password.getAttribute("type") === "password" ? "text" : "password";
    if (type === "password") {
      this.classList.remove("fa-eye");
      this.classList.add("fa-eye-slash");
    } else {
      this.classList.remove("fa-eye-slash");
      this.classList.add("fa-eye");
    }
    password.setAttribute("type", type);
  }

  document.querySelectorAll(".fa-eye-slash").forEach((icon) => {
    icon.onclick = toggleChangeEyeIcon;
  });

  const glideCarousel = document.querySelector(".glide");
  if (glideCarousel) {
    const slideCount = glideCarousel.querySelectorAll(".glide__slide").length;
    const clampPerView = (n) => Math.min(n, Math.max(slideCount, 1));
    new Glide(glideCarousel, {
      type: "carousel",
      perView: clampPerView(3),
      rewind: slideCount > 3,
      //focusAt: 'center',
      breakpoints: {
        1199: {
          perView: clampPerView(2),
        },
        767: {
          perView: clampPerView(1),
        },
      },
    }).mount();
  }
  const glideCarousel2 = document.querySelector(".glide2");
  if (glideCarousel2) {
    new Glide(glideCarousel2, {
      type: "carousel",
      perView: 3,
      rewind: true,
      //focusAt: 'center',
      breakpoints: {
        1199: {
          perView: 2,
        },
        767: {
          perView: 1,
        },
      },
    }).mount();
  }

  $(".showReceipt").on('click', function(){
    let img = $(this).data('receipt-img')
    let link = $(this).data('receipt-link')

    $('#receiptLink').prop('href', link);
    $('#receiptImg').prop('src', img);
  });
});


window.addEventListener("pageshow", function () { window.scrollTo(0, 0); });

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      registration.addEventListener("updatefound", () => {
        // If updatefound is fired, it means that there's
        // a new service worker being installed.
        const installingWorker = registration.installing;
        console.log("Instalando un nuevo worker:", installingWorker);

        // You can listen for changes to the installing service worker's
        // state via installingWorker.onstatechange
      });
    })
    .catch((error) => {
      console.error(`Fallo al registrar el Service worker: ${error}`);
    });
} else {
  console.error("Service workers are not supported.");
}